import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errors: {},
};

const formGeneratorSlice = createSlice({
  name: "formGenerator",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    removeError(state, action) {
      const { [action.payload]: _, ...rest } = state.errors;
      return { ...state, errors: rest };
    },
    resetErrors() {
      return initialState;
    },
  },
});

export const formGeneratorActions = formGeneratorSlice.actions;
export default formGeneratorSlice;
